import { Component, ElementRef, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-note-pm',
  templateUrl: './note-pm.component.html',
  styleUrls: ['./note-pm.component.css']
})
export class NotePMComponent implements OnInit {


  ngOnInit(): void {
  }

   //SpeechRecognition:any =webkitSpeechRecognition;
  
   recognition:any;

   @Output() dismiss = new EventEmitter();
   @Output() focusout = new EventEmitter();
   constructor(private el:ElementRef) {
    const {webkitSpeechRecognition} : IWindow = <IWindow><unknown>window;
     this.recognition = new webkitSpeechRecognition();
     this.recognition.onresult = (event)=> {
       this.el.nativeElement.querySelector(".content").innerText += event.results[0][0].transcript
       document.getElementById('toolbar').focus();
     };
   }
   
   onDismiss(event){
     this.dismiss.emit(event);
   }
   
   onFocusOut(event){
     this.focusout.emit(event)
   }
 
   record(event) {
     this.recognition.start();
   }
 
 }
 
 export interface IWindow extends Window {
   webkitSpeechRecognition: any;
 }


